module.exports = __webpack_public_path__ + "img/5.8a388595.png";